export const Crest = ({ light = false, className = "h-10" }) => (
  <span
    className={`inline-flex items-center ${light ? "text-ivory" : "text-navy"} ${className}`}
    data-testid="cvi-logo"
    role="img"
    aria-label="Cardio-Vascular Imaging (UK) Ltd"
  >
    <svg viewBox="0 0 400 83" className="h-full w-auto" xmlns="http://www.w3.org/2000/svg">
      <image
        href="/logo-icon.png"
        x="0"
        y="1"
        width="81"
        height="81"
        style={light ? { filter: "brightness(0) invert(1)" } : undefined}
      />
      <text
        x="96"
        y="42"
        fontFamily="'Plus Jakarta Sans', sans-serif"
        fontWeight="500"
        fontSize="26"
        fill="currentColor"
        textLength="296"
        lengthAdjust="spacingAndGlyphs"
      >
        Cardio-Vascular Imaging
      </text>
      <text
        x="244"
        y="66"
        fontFamily="'Plus Jakarta Sans', sans-serif"
        fontWeight="600"
        fontSize="13"
        letterSpacing="4"
        fill="currentColor"
        textAnchor="middle"
      >
        (UK) LTD
      </text>
    </svg>
  </span>
);
